export const REGIONS = [
  {
    "name": "National Capital Region",
    "region": "National Capital Region",
    "typeDescription": "Region"
  },
  {
    "name": "Cagayan Valley",
    "region": "Cagayan Valley",
    "typeDescription": "Region"
  },
  {
    "name": "South Luzon",
    "region": "South Luzon",
    "typeDescription": "Region"
  },
  {
    "name": "Central Visayas",
    "region": "Central Visayas",
    "typeDescription": "Region"
  },
  {
    "name": "Eastern Visayas",
    "region": "Eastern Visayas",
    "typeDescription": "Region"
  },
  {
    "name": "Cebu",
    "region": "Cebu",
    "typeDescription": "Region"
  },
  {
    "name": "Western Visayas",
    "region": "Western Visayas",
    "typeDescription": "Region"
  },
  {
    "name": "Mimaropa",
    "region": "Mimaropa",
    "typeDescription": "Region"
  },
  {
    "name": "Cordillera Administrative Region",
    "region": "Cordillera Administrative Region",
    "typeDescription": "Region"
  },
  {
    "name": "Calabarzon",
    "region": "Calabarzon",
    "typeDescription": "Region"
  },
  {
    "name": "Negros Island Region",
    "region": "Negros Island Region",
    "typeDescription": "Region"
  },
  {
    "name": "Central Luzon",
    "region": "Central Luzon",
    "typeDescription": "Region"
  },
  {
    "name": "Davao Region",
    "region": "Davao Region",
    "typeDescription": "Region"
  },
  {
    "name": "North Luzon",
    "region": "North Luzon",
    "typeDescription": "Region"
  },
  {
    "name": "Bicol Region",
    "region": "Bicol Region",
    "typeDescription": "Region"
  },
  {
    "name": "Northern Mindanao",
    "region": "Northern Mindanao",
    "typeDescription": "Region"
  },
  {
    "name": "Zamboanga Peninsula",
    "region": "Zamboanga Peninsula",
    "typeDescription": "Region"
  },
  {
    "name": "Soccsksargen",
    "region": "Soccsksargen",
    "typeDescription": "Region"
  }
];
